// eslint-disable-next-line import/no-default-export
export default {
    REDUCER_KEY: "EMPLOYEE_ACCOUNT",
    ENTITY_NAME: "employeeAccount",
    RESOURCE: "_",
};
